import CardCommon from '@op/components/CardCommon';
import React, { useMemo } from 'react';
import { ISteam } from '../../../type';
import CommonTitle from '../CommonTitle';
import LinkTab from '@op/components/LinkTab';
import { TabPanel } from 'tea-component';
import { REALTIME_METRICS_STEAM_OPTIONS, REALTIME_STEAM_TIMELINE_CONFIG } from '../../../constant';
import SteamMetricsCard from '../../../component/SteamMetricsCard';
import {
  dealwithSteamLinkDataInfo,
} from '@op/pages/gamestore/hooks/useGetPcConsoleStats';
import './index.scss';
import { DBO_TM } from '@op/utils/format';
import { useRealtimeSteamAddedReviews, useRealtimeSteamStats } from '../../../hook';
import SteamPerformanceChart from './SteamPerformanceChart';
import { useHistory } from 'umi';
import RealtimeSteamFeedsReviewsDetailed from './RealtimeSteamFeedsReviewsDetailed';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
export default function Steam({ filter, gameInfo, deadline, wholeGameInfo }: ISteam) {
  const isToday = useMemo(() => DBO_TM.isToday(filter), [filter]);
  const history = useHistory();
  const filterParams = useMemo(() => {
    if (isToday) {
      return {
        ...filter,
        channel: ['steam'],
        channels: ['steam'],
        date_type: 'hourly',
        need_link: true,
        need_many_hour_ago: isToday,
        many_hour_ago: 0
      };
    }
    return {
      ...filter,
      channel: ['steam'],
      channels: ['steam'],
      need_link: true,
      date_type: 'hourly'
    };
  }, [filter, isToday]);

  const steamFilter = useMemo(() => {
    const { channels, statistics_field, ...filter } = filterParams;
    return {
      ...filter,
      should_return_overview_response: true
    };
  }, [filterParams]);

  const { data: userScore, timeline, loading: userScoreLoading, refetch } = useRealtimeSteamStats({
    filter: filterParams
  });

  const { data: timelineData } = useRealtimeSteamAddedReviews({
    data: timeline,
    extraData: {
      config: REALTIME_STEAM_TIMELINE_CONFIG
    }
  });


  const tabRenderData = useMemo(() => {
    // all_reviews: steam官方，select_all_views: 平台
    return dealwithSteamLinkDataInfo(userScore, isToday);
  }, [userScore]);

  return (
    <CardCommon
      contentCard
      title={
        <CommonTitle
          title={"Steam Performance-1"}
          endTime={userScore.end_time}
          hasTitleArrow
          handleTitleOnClick={() => {
            history.push('/opinion/SteamPerformance/SteamRatings');
          }} ></CommonTitle>}
      className='dbo-realtime-steam-wrapper'
    >
      <LinkTab
        tabs={REALTIME_METRICS_STEAM_OPTIONS.map((item) => {
          return {
            label: (
              <SteamMetricsCard
                data={tabRenderData}
                tabItem={item}
                filter={filterParams}
                // loading={userScoreLoading}
                isToday={isToday}
              />
            ),
            id: item.valueKey,
          };
        })}
        onActive={(tab: any) => {
          buriedBtnPoint('RO_Steam_Tab', tab.id);
          refetch(true);
        }}
      >
        {REALTIME_METRICS_STEAM_OPTIONS.map((item) => {
          return (
            <TabPanel key={item.valueKey} id={item.valueKey}>
              <SteamPerformanceChart
                filter={filterParams}
                gameInfo={gameInfo}
                wholeGameInfo={wholeGameInfo}
                tab={item.valueKey}
                userScore={userScore}
                userScoreLoading={userScoreLoading}
                timelineData={timelineData}
                timelineLoading={userScoreLoading}
              />
            </TabPanel>
          );
        })}
      </LinkTab>
      {/*  statsDetailType=""  statsLanguageDetailType="" */}
      <RealtimeSteamFeedsReviewsDetailed
        hasFeedsBtn={false}
        isStacked
        filter={steamFilter}
      ></RealtimeSteamFeedsReviewsDetailed>
    </CardCommon>
  );
}
